import React from 'react'
import { BarChart, BarSeriesType } from '@mui/x-charts'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatPercentage } from '../../../packages/utils/numberFormatters'
import { CustomAxisTooltip } from './CustomTooltip'

interface HorizontalBarChartProps {
    isLeftAlign?: boolean
    labelValue: number
    series: Pick<BarSeriesType, 'data' | 'color' | 'label'>[]
    skipAnimation?: boolean
    valueDecimals?: number
}

function HorizontalBarChart({
    isLeftAlign,
    labelValue,
    series,
    skipAnimation = true,
    valueDecimals = 1,
}: HorizontalBarChartProps) {
    const { i18n } = useTranslation()
    const locale = i18n.language
    const valueFormatter = (value: number | null) => formatPercentage(value, { locale, decimals: valueDecimals })

    const mappedSeries: BarSeriesType[] = series.map((s) => ({
        ...s,
        type: 'bar',
        stack: 'A',
        valueFormatter,
        stackOffset: 'expand',
        data: s.data?.map((d) => {
            if (typeof d === 'string') {
                return parseFloat(d)
            }
            return d
        }),
    }))

    return (
        <Box
            sx={{
                height: 20,
                display: 'flex',
                marginLeft: isLeftAlign ? -11 : -7,
                justifySelf: isLeftAlign ? 'flex-start' : undefined,
            }}
        >
            <BarChart
                skipAnimation={skipAnimation}
                layout='horizontal'
                xAxis={[{ position: 'none', max: 1 }]}
                slots={{
                    tooltip: CustomAxisTooltip,
                }}
                slotProps={{
                    tooltip: {
                        trigger: 'axis',
                    },
                }}
                series={mappedSeries}
                margin={{ top: 0, left: 0, bottom: 0 }}
                sx={{
                    '.MuiChartsAxis-root': {
                        display: 'none',
                    },
                }}
                width={160}
                hideLegend={true}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', width: '70px' }}>
                {formatPercentage(labelValue, { locale, decimals: 0 })}
            </Box>
        </Box>
    )
}

export default HorizontalBarChart
